import { render, staticRenderFns } from "./Rumah.vue?vue&type=template&id=a70d3828&scoped=true"
import script from "./Rumah.vue?vue&type=script&lang=js"
export * from "./Rumah.vue?vue&type=script&lang=js"
import style0 from "./Rumah.vue?vue&type=style&index=0&id=a70d3828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70d3828",
  null
  
)

export default component.exports